import React, { useState } from "react";
import ConfirmPasswordModal from "./ConfirmPasswordModal";
import { useAuth } from "../context/AuthContext";

const FolderTable = ({ folders, detailsFolder, deleteFolder, folderDetailsModal, addFolderFavorite }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const { user } = useAuth();
  // ✅ Open ConfirmPasswordModal when delete is triggered
  const handleDelete = (entityId) => {
    setSelectedFolder(entityId);
    setShowConfirmModal(true);
  };

  // ✅ Execute delete after confirmation
  const confirmDelete = async () => {
    if (selectedFolder) {
      await deleteFolder(selectedFolder);
      setSelectedFolder(null);
      setShowConfirmModal(false);
    }
  };

  return (
    <div className="shared_folder_body">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Uploaded</th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          {folders.length > 0 ? (
            folders.map((folder) => (
              <tr key={folder.entity_id}>
                <td>
                  <div className="floder_dtls">
                    <span
                      className="star"
                      type="button"
                      onClick={() => addFolderFavorite(folder.entity_id, folder.is_favorite)}
                    >
                      <i
                        className={folder.is_favorite === false ? "fa-regular fa-star" : "fa-solid fa-star"}
                      ></i>
                    </span>
                    <div className="floder_dtls_inner">
                      <div
                        className="folder-clickable floder_dtls_inner"
                        onClick={() => detailsFolder(folder.entity_id)}
                        style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                      >
                        <span><i className="fa-solid fa-folder-open"></i></span>
                        <p>{folder.entity_name}</p>
                      </div>
                     
                      <em type="button" onClick={() => folderDetailsModal(folder.entity_id)}>
                        <i className="fa-solid fa-circle-info"></i>
                      </em>
                     
                    </div>
                  </div>
                </td>
                <td>
                  {folder.entity_created
                    ? new Date(folder.entity_created).toLocaleString("en-GB", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: false,
                      }).replace(",", "")
                    : "N/A"}
                </td>
                <td>
                  <div className="share_dtls_btn_holder">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => detailsFolder(folder.entity_id)}
                    >
                      <span><i className="fa-solid fa-eye"></i>Details</span>
                    </button>
                    {typeof deleteFolder === "function" && 
                    user?.user_role?.toLowerCase() !== "client" && (
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => handleDelete(folder.entity_id)}
                      >
                        <span><i className="fa-solid fa-trash-can"></i></span> Delete
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", padding: "20px" }}>
                No Folders Found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* ✅ Confirm Password Modal */}
      <ConfirmPasswordModal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onSuccess={confirmDelete}
      />
    </div>
  );
};

export default FolderTable;
